const mapping = [
  {
    code_a2: 'ad',
    code_a3: 'and',
    name: 'Andorra'
  },
  {
    code_a2: 'ae',
    code_a3: 'are',
    name: 'United Arab Emirates'
  },
  {
    code_a2: 'af',
    code_a3: 'afg',
    name: 'Afghanistan'
  },
  {
    code_a2: 'ag',
    code_a3: 'atg',
    name: 'Antigua and Barbuda'
  },
  {
    code_a2: 'ai',
    code_a3: 'aia',
    name: 'Anguilla'
  },
  {
    code_a2: 'al',
    code_a3: 'alb',
    name: 'Albania'
  },
  {
    code_a2: 'am',
    code_a3: 'arm',
    name: 'Armenia'
  },
  {
    code_a2: 'ao',
    code_a3: 'ago',
    name: 'Angola'
  },
  {
    code_a2: 'aq',
    code_a3: 'ata',
    name: 'Antarctica'
  },
  {
    code_a2: 'ar',
    code_a3: 'arg',
    name: 'Argentina'
  },
  {
    code_a2: 'as',
    code_a3: 'asm',
    name: 'American Samoa'
  },
  {
    code_a2: 'at',
    code_a3: 'aut',
    name: 'Austria'
  },
  {
    code_a2: 'au',
    code_a3: 'aus',
    name: 'Australia'
  },
  {
    code_a2: 'aw',
    code_a3: 'abw',
    name: 'Aruba'
  },
  {
    code_a2: 'ax',
    code_a3: 'ala',
    name: 'Aland Islands'
  },
  {
    code_a2: 'az',
    code_a3: 'aze',
    name: 'Azerbaijan'
  },
  {
    code_a2: 'ba',
    code_a3: 'bih',
    name: 'Bosnia and Herzegovina'
  },
  {
    code_a2: 'bb',
    code_a3: 'brb',
    name: 'Barbados'
  },
  {
    code_a2: 'bd',
    code_a3: 'bgd',
    name: 'Bangladesh'
  },
  {
    code_a2: 'be',
    code_a3: 'bel',
    name: 'Belgium'
  },
  {
    code_a2: 'bf',
    code_a3: 'bfa',
    name: 'Burkina Faso'
  },
  {
    code_a2: 'bg',
    code_a3: 'bgr',
    name: 'Bulgaria'
  },
  {
    code_a2: 'bh',
    code_a3: 'bhr',
    name: 'Bahrain'
  },
  {
    code_a2: 'bi',
    code_a3: 'bdi',
    name: 'Burundi'
  },
  {
    code_a2: 'bj',
    code_a3: 'ben',
    name: 'Benin'
  },
  {
    code_a2: 'bl',
    code_a3: 'blm',
    name: 'Saint-Barthélemy'
  },
  {
    code_a2: 'bm',
    code_a3: 'bmu',
    name: 'Bermuda'
  },
  {
    code_a2: 'bn',
    code_a3: 'brn',
    name: 'Brunei Darussalam'
  },
  {
    code_a2: 'bo',
    code_a3: 'bol',
    name: 'Bolivia'
  },
  {
    code_a2: 'bq',
    code_a3: 'bes',
    name: 'Caribbean Netherlands'
  },
  {
    code_a2: 'br',
    code_a3: 'bra',
    name: 'Brazil'
  },
  {
    code_a2: 'bs',
    code_a3: 'bhs',
    name: 'Bahamas'
  },
  {
    code_a2: 'bt',
    code_a3: 'btn',
    name: 'Bhutan'
  },
  {
    code_a2: 'bv',
    code_a3: 'bvt',
    name: 'Bouvet Island'
  },
  {
    code_a2: 'bw',
    code_a3: 'bwa',
    name: 'Botswana'
  },
  {
    code_a2: 'by',
    code_a3: 'blr',
    name: 'Belarus'
  },
  {
    code_a2: 'bz',
    code_a3: 'blz',
    name: 'Belize'
  },
  {
    code_a2: 'ca',
    code_a3: 'can',
    name: 'Canada'
  },
  {
    code_a2: 'cc',
    code_a3: 'cck',
    name: 'Cocos (Keeling) Islands'
  },
  {
    code_a2: 'cd',
    code_a3: 'cod',
    name: 'Democratic Republic of the Congo'
  },
  {
    code_a2: 'cf',
    code_a3: 'caf',
    name: 'Centrafrican Republic'
  },
  {
    code_a2: 'cg',
    code_a3: 'cog',
    name: 'Republic of the Congo'
  },
  {
    code_a2: 'ch',
    code_a3: 'che',
    name: 'Switzerland'
  },
  {
    code_a2: 'ci',
    code_a3: 'civ',
    name: "Côte d'Ivoire"
  },
  {
    code_a2: 'ck',
    code_a3: 'cok',
    name: 'Cook Islands'
  },
  {
    code_a2: 'cl',
    code_a3: 'chl',
    name: 'Chile'
  },
  {
    code_a2: 'cm',
    code_a3: 'cmr',
    name: 'Cameroon'
  },
  {
    code_a2: 'cn',
    code_a3: 'chn',
    name: 'China'
  },
  {
    code_a2: 'co',
    code_a3: 'col',
    name: 'Colombia'
  },
  {
    code_a2: 'cr',
    code_a3: 'cri',
    name: 'Costa Rica'
  },
  {
    code_a2: 'cu',
    code_a3: 'cub',
    name: 'Cuba'
  },
  {
    code_a2: 'cv',
    code_a3: 'cpv',
    name: 'Cabo Verde'
  },
  {
    code_a2: 'cw',
    code_a3: 'cuw',
    name: 'Curaçao'
  },
  {
    code_a2: 'cx',
    code_a3: 'cxr',
    name: 'Christmas Island'
  },
  {
    code_a2: 'cy',
    code_a3: 'cyp',
    name: 'Cyprus'
  },
  {
    code_a2: 'cz',
    code_a3: 'cze',
    name: 'Czech Republic'
  },
  {
    code_a2: 'de',
    code_a3: 'deu',
    name: 'Germany'
  },
  {
    code_a2: 'dj',
    code_a3: 'dji',
    name: 'Djibouti'
  },
  {
    code_a2: 'dk',
    code_a3: 'dnk',
    name: 'Denmark'
  },
  {
    code_a2: 'dm',
    code_a3: 'dma',
    name: 'Dominica'
  },
  {
    code_a2: 'do',
    code_a3: 'dom',
    name: 'Dominican Republic'
  },
  {
    code_a2: 'dz',
    code_a3: 'dza',
    name: 'Algeria'
  },
  {
    code_a2: 'ec',
    code_a3: 'ecu',
    name: 'Ecuador'
  },
  {
    code_a2: 'ee',
    code_a3: 'est',
    name: 'Estonia'
  },
  {
    code_a2: 'eg',
    code_a3: 'egy',
    name: 'Egypt'
  },
  {
    code_a2: 'eh',
    code_a3: 'esh',
    name: 'Western Sahara'
  },
  {
    code_a2: 'er',
    code_a3: 'eri',
    name: 'Eritrea'
  },
  {
    code_a2: 'es',
    code_a3: 'esp',
    name: 'Spain'
  },
  {
    code_a2: 'et',
    code_a3: 'eth',
    name: 'Ethiopia'
  },
  {
    code_a2: 'eu',
    code_a3: 'eur',
    name: 'Europe'
  },
  {
    code_a2: 'fi',
    code_a3: 'fin',
    name: 'Finland'
  },
  {
    code_a2: 'fj',
    code_a3: 'fji',
    name: 'Fiji'
  },
  {
    code_a2: 'fk',
    code_a3: 'flk',
    name: 'Falkland Islands'
  },
  {
    code_a2: 'fm',
    code_a3: 'fsm',
    name: 'Micronesia'
  },
  {
    code_a2: 'fo',
    code_a3: 'fro',
    name: 'Faroe Islands'
  },
  {
    lang: 'fr',
    code_a2: 'fr',
    code_a3: 'fra',
    name: 'France'
  },
  {
    code_a2: 'ga',
    code_a3: 'gab',
    name: 'Gabon'
  },
  {
    lang: 'en',
    code_a2: 'gb',
    code_a3: 'gbr',
    name: 'United Kingdom'
  },
  {
    code_a2: 'gd',
    code_a3: 'grd',
    name: 'Grenada'
  },
  {
    code_a2: 'ge',
    code_a3: 'geo',
    name: 'Georgia'
  },
  {
    code_a2: 'gf',
    code_a3: 'guf',
    name: 'French Guiana'
  },
  {
    code_a2: 'gg',
    code_a3: 'ggy',
    name: 'Guernsey'
  },
  {
    code_a2: 'gh',
    code_a3: 'gha',
    name: 'Ghana'
  },
  {
    code_a2: 'gi',
    code_a3: 'gib',
    name: 'Gibraltar'
  },
  {
    code_a2: 'gl',
    code_a3: 'grl',
    name: 'Greenland'
  },
  {
    code_a2: 'gm',
    code_a3: 'gmb',
    name: 'The Gambia'
  },
  {
    code_a2: 'gn',
    code_a3: 'gin',
    name: 'Guinea'
  },
  {
    code_a2: 'gp',
    code_a3: 'glp',
    name: 'Guadeloupe'
  },
  {
    code_a2: 'gq',
    code_a3: 'gnq',
    name: 'Equatorial Guinea'
  },
  {
    code_a2: 'gr',
    code_a3: 'grc',
    name: 'Greece'
  },
  {
    code_a2: 'gs',
    code_a3: 'sgs',
    name: 'South Georgia and the South Sandwich Islands'
  },
  {
    code_a2: 'gt',
    code_a3: 'gtm',
    name: 'Guatemala'
  },
  {
    code_a2: 'gu',
    code_a3: 'gum',
    name: 'Guam'
  },
  {
    code_a2: 'gw',
    code_a3: 'gnb',
    name: 'Guinea Bissau'
  },
  {
    code_a2: 'gy',
    code_a3: 'guy',
    name: 'Guyana'
  },
  {
    code_a2: 'hk',
    code_a3: 'hkg',
    name: 'Hong Kong'
  },
  {
    code_a2: 'hm',
    code_a3: 'hmd',
    name: 'Heard Island and McDonald Islands'
  },
  {
    code_a2: 'hn',
    code_a3: 'hnd',
    name: 'Honduras'
  },
  {
    code_a2: 'hr',
    code_a3: 'hrv',
    name: 'Croatia'
  },
  {
    code_a2: 'ht',
    code_a3: 'hti',
    name: 'Haiti'
  },
  {
    code_a2: 'hu',
    code_a3: 'hun',
    name: 'Hungary'
  },
  {
    code_a2: 'id',
    code_a3: 'idn',
    name: 'Indonesia'
  },
  {
    code_a2: 'ie',
    code_a3: 'irl',
    name: 'Ireland'
  },
  {
    code_a2: 'xi',
    code_a3: 'nir',
    name: 'Northern Ireland'
  },
  {
    code_a2: 'il',
    code_a3: 'isr',
    name: 'Israel'
  },
  {
    code_a2: 'im',
    code_a3: 'imn',
    name: 'Isle of Man'
  },
  {
    code_a2: 'in',
    code_a3: 'ind',
    name: 'India'
  },
  {
    code_a2: 'io',
    code_a3: 'iot',
    name: 'British Indian Ocean Territory'
  },
  {
    code_a2: 'iq',
    code_a3: 'irq',
    name: 'Iraq'
  },
  {
    code_a2: 'ir',
    code_a3: 'irn',
    name: 'Iran'
  },
  {
    code_a2: 'is',
    code_a3: 'isl',
    name: 'Iceland'
  },
  {
    code_a2: 'it',
    code_a3: 'ita',
    name: 'Italy'
  },
  {
    code_a2: 'je',
    code_a3: 'jey',
    name: 'Jersey'
  },
  {
    code_a2: 'jm',
    code_a3: 'jam',
    name: 'Jamaica'
  },
  {
    code_a2: 'jo',
    code_a3: 'jor',
    name: 'Jordan'
  },
  {
    code_a2: 'jp',
    code_a3: 'jpn',
    name: 'Japan'
  },
  {
    code_a2: 'ke',
    code_a3: 'ken',
    name: 'Kenya'
  },
  {
    code_a2: 'kg',
    code_a3: 'kgz',
    name: 'Kyrgyzstan'
  },
  {
    code_a2: 'kh',
    code_a3: 'khm',
    name: 'Cambodia'
  },
  {
    code_a2: 'ki',
    code_a3: 'kir',
    name: 'Kiribati'
  },
  {
    code_a2: 'km',
    code_a3: 'com',
    name: 'Comoros'
  },
  {
    code_a2: 'kn',
    code_a3: 'kna',
    name: 'Saint Kitts and Nevis'
  },
  {
    code_a2: 'kp',
    code_a3: 'prk',
    name: 'North Korea'
  },
  {
    code_a2: 'kr',
    code_a3: 'kor',
    name: 'South Korea'
  },
  {
    code_a2: 'kr',
    code_a3: 'kor',
    name: 'KOREA (THE REPUBLIC OF)'
  },
  {
    code_a2: 'kw',
    code_a3: 'kwt',
    name: 'Kuwait'
  },
  {
    code_a2: 'ky',
    code_a3: 'cym',
    name: 'Cayman Islands'
  },
  {
    code_a2: 'kz',
    code_a3: 'kaz',
    name: 'Kazakhstan'
  },
  {
    code_a2: 'la',
    code_a3: 'lao',
    name: 'Laos'
  },
  {
    code_a2: 'lb',
    code_a3: 'lbn',
    name: 'Lebanon'
  },
  {
    code_a2: 'lc',
    code_a3: 'lca',
    name: 'Saint Lucia'
  },
  {
    code_a2: 'li',
    code_a3: 'lie',
    name: 'Liechtenstein'
  },
  {
    code_a2: 'lk',
    code_a3: 'lka',
    name: 'Sri Lanka'
  },
  {
    code_a2: 'lr',
    code_a3: 'lbr',
    name: 'Liberia'
  },
  {
    code_a2: 'ls',
    code_a3: 'lso',
    name: 'Lesotho'
  },
  {
    code_a2: 'lt',
    code_a3: 'ltu',
    name: 'Lithuania'
  },
  {
    code_a2: 'lu',
    code_a3: 'lux',
    name: 'Luxembourg'
  },
  {
    code_a2: 'lv',
    code_a3: 'lva',
    name: 'Latvia'
  },
  {
    code_a2: 'ly',
    code_a3: 'lby',
    name: 'Libya'
  },
  {
    code_a2: 'ma',
    code_a3: 'mar',
    name: 'Morocco'
  },
  {
    code_a2: 'mc',
    code_a3: 'mco',
    name: 'Monaco'
  },
  {
    code_a2: 'md',
    code_a3: 'mda',
    name: 'Moldova'
  },
  {
    code_a2: 'me',
    code_a3: 'mne',
    name: 'Montenegro'
  },
  {
    code_a2: 'mf',
    code_a3: 'maf',
    name: 'Saint Martin (French part)'
  },
  {
    code_a2: 'mg',
    code_a3: 'mdg',
    name: 'Madagascar'
  },
  {
    code_a2: 'mh',
    code_a3: 'mhl',
    name: 'Marshall Islands'
  },
  {
    code_a2: 'mk',
    code_a3: 'mkd',
    name: 'North Macedonia'
  },
  {
    code_a2: 'ml',
    code_a3: 'mli',
    name: 'Mali'
  },
  {
    code_a2: 'mm',
    code_a3: 'mmr',
    name: 'Myanmar'
  },
  {
    code_a2: 'mn',
    code_a3: 'mng',
    name: 'Mongolia'
  },
  {
    code_a2: 'mo',
    code_a3: 'mac',
    name: 'Macao (SAR of China)'
  },
  {
    code_a2: 'mp',
    code_a3: 'mnp',
    name: 'Northern Mariana Islands'
  },
  {
    code_a2: 'mq',
    code_a3: 'mtq',
    name: 'Martinique'
  },
  {
    code_a2: 'mr',
    code_a3: 'mrt',
    name: 'Mauritania'
  },
  {
    code_a2: 'ms',
    code_a3: 'msr',
    name: 'Montserrat'
  },
  {
    code_a2: 'mt',
    code_a3: 'mlt',
    name: 'Malta'
  },
  {
    code_a2: 'mu',
    code_a3: 'mus',
    name: 'Mauritius'
  },
  {
    code_a2: 'mv',
    code_a3: 'mdv',
    name: 'Maldives'
  },
  {
    code_a2: 'mw',
    code_a3: 'mwi',
    name: 'Malawi'
  },
  {
    code_a2: 'mx',
    code_a3: 'mex',
    name: 'Mexico'
  },
  {
    code_a2: 'my',
    code_a3: 'mys',
    name: 'Malaysia'
  },
  {
    code_a2: 'mz',
    code_a3: 'moz',
    name: 'Mozambique'
  },
  {
    code_a2: 'na',
    code_a3: 'nam',
    name: 'Namibia'
  },
  {
    code_a2: 'nc',
    code_a3: 'ncl',
    name: 'New Caledonia'
  },
  {
    code_a2: 'ne',
    code_a3: 'ner',
    name: 'Niger'
  },
  {
    code_a2: 'nf',
    code_a3: 'nfk',
    name: 'Norfolk Island'
  },
  {
    code_a2: 'ng',
    code_a3: 'nga',
    name: 'Nigeria'
  },
  {
    code_a2: 'ni',
    code_a3: 'nic',
    name: 'Nicaragua'
  },
  {
    code_a2: 'nl',
    code_a3: 'nld',
    name: 'The Netherlands'
  },
  {
    code_a2: 'no',
    code_a3: 'nor',
    name: 'Norway'
  },
  {
    code_a2: 'np',
    code_a3: 'npl',
    name: 'Nepal'
  },
  {
    code_a2: 'nr',
    code_a3: 'nru',
    name: 'Nauru'
  },
  {
    code_a2: 'nu',
    code_a3: 'niu',
    name: 'Niue'
  },
  {
    code_a2: 'nz',
    code_a3: 'nzl',
    name: 'New Zealand'
  },
  {
    code_a2: 'om',
    code_a3: 'omn',
    name: 'Oman'
  },
  {
    code_a2: 'pa',
    code_a3: 'pan',
    name: 'Panama'
  },
  {
    code_a2: 'pe',
    code_a3: 'per',
    name: 'Peru'
  },
  {
    code_a2: 'pf',
    code_a3: 'pyf',
    name: 'French Polynesia'
  },
  {
    code_a2: 'pg',
    code_a3: 'png',
    name: 'Papua New Guinea'
  },
  {
    code_a2: 'ph',
    code_a3: 'phl',
    name: 'Philippines'
  },
  {
    code_a2: 'pk',
    code_a3: 'pak',
    name: 'Pakistan'
  },
  {
    code_a2: 'pl',
    code_a3: 'pol',
    name: 'Poland'
  },
  {
    code_a2: 'pm',
    code_a3: 'spm',
    name: 'Saint Pierre and Miquelon'
  },
  {
    code_a2: 'pn',
    code_a3: 'pcn',
    name: 'Pitcairn'
  },
  {
    code_a2: 'pr',
    code_a3: 'pri',
    name: 'Puerto Rico'
  },
  {
    code_a2: 'ps',
    code_a3: 'pse',
    name: 'Palestinian Territory'
  },
  {
    code_a2: 'pt',
    code_a3: 'prt',
    name: 'Portugal'
  },
  {
    code_a2: 'pw',
    code_a3: 'plw',
    name: 'Palau'
  },
  {
    code_a2: 'py',
    code_a3: 'pry',
    name: 'Paraguay'
  },
  {
    code_a2: 'qa',
    code_a3: 'qat',
    name: 'Qatar'
  },
  {
    __comment__: "This is not a real country, it's destinations defined by EU trade administration",
    code_a2: 'qp',
    code_a3: 'qp',
    name: 'High seas (Maritime domain outside of territorial waters)'
  },
  {
    __comment__: "This is not a real country, it's destinations defined by EU trade administration",
    code_a2: 'qq',
    code_a3: 'qq',
    name: 'Stores and provisions'
  },
  {
    __comment__: "This is not a real country, it's destinations defined by EU trade administration",
    code_a2: 'qr',
    code_a3: 'qr',
    name: 'Stores and provisions within the framework of intra-community trade'
  },
  {
    __comment__: "This is not a real country, it's destinations defined by EU trade administration",
    code_a2: 'qs',
    code_a3: 'qs',
    name: 'Stores and provisions within the framework of trade with third countries'
  },
  {
    __comment__: "This is not a real country, it's destinations defined by EU trade administration",
    code_a2: 'qu',
    code_a3: 'qu',
    name: 'Countries and territories not specified'
  },
  {
    __comment__: "This is not a real country, it's destinations defined by EU trade administration",
    code_a2: 'qv',
    code_a3: 'qv',
    name: 'Countries and territories not specified in the framework of intra-Community trade'
  },
  {
    __comment__: "This is not a real country, it's destinations defined by EU trade administration",
    code_a2: 'qw',
    code_a3: 'qw',
    name: 'Countries and territories not specified in the framework of trace with third countries'
  },
  {
    __comment__: "This is not a real country, it's destinations defined by EU trade administration",
    code_a2: 'qx',
    code_a3: 'qx',
    name: 'Countries and territories not specified for commercial or military reasons'
  },
  {
    __comment__: "This is not a real country, it's destinations defined by EU trade administration",
    code_a2: 'qy',
    code_a3: 'qy',
    name: 'Countries and territories not specified for commercial or military reasons in the framework of intra-Community trade'
  },
  {
    __comment__: "This is not a real country, it's destinations defined by EU trade administration",
    code_a2: 'qz',
    code_a3: 'qz',
    name: 'Countries and territories not specified for commercial or military reasons in the framework of trade with third countries'
  },
  {
    code_a2: 're',
    code_a3: 'reu',
    name: 'Réunion'
  },
  {
    code_a2: 'ro',
    code_a3: 'rou',
    name: 'Romania'
  },
  {
    code_a2: 'rs',
    code_a3: 'srb',
    name: 'Serbia'
  },
  {
    code_a2: 'xs', // EU decided to take an other code for serbia...
    code_a3: 'srb',
    name: 'Serbia'
  },
  {
    code_a2: 'ru',
    code_a3: 'rus',
    name: 'Russia'
  },
  {
    code_a2: 'rw',
    code_a3: 'rwa',
    name: 'Rwanda'
  },
  {
    code_a2: 'sa',
    code_a3: 'sau',
    name: 'Saudi Arabia'
  },
  {
    code_a2: 'sb',
    code_a3: 'slb',
    name: 'Solomon Islands'
  },
  {
    code_a2: 'sc',
    code_a3: 'syc',
    name: 'Seychelles'
  },
  {
    code_a2: 'sd',
    code_a3: 'sdn',
    name: 'Sudan'
  },
  {
    code_a2: 'se',
    code_a3: 'swe',
    name: 'Sweden'
  },
  {
    code_a2: 'sg',
    code_a3: 'sgp',
    name: 'Singapore'
  },
  {
    code_a2: 'sh',
    code_a3: 'shn',
    name: 'Saint Helena'
  },
  {
    code_a2: 'si',
    code_a3: 'svn',
    name: 'Slovenia'
  },
  {
    code_a2: 'sj',
    code_a3: 'sjm',
    name: 'Svalbard and Jan Mayen'
  },
  {
    code_a2: 'sk',
    code_a3: 'svk',
    name: 'Slovakia'
  },
  {
    code_a2: 'sl',
    code_a3: 'sle',
    name: 'Sierra Leone'
  },
  {
    code_a2: 'sm',
    code_a3: 'smr',
    name: 'San Marino'
  },
  {
    code_a2: 'sn',
    code_a3: 'sen',
    name: 'Sénégal'
  },
  {
    code_a2: 'so',
    code_a3: 'som',
    name: 'Somalia'
  },
  {
    code_a2: 'sr',
    code_a3: 'sur',
    name: 'Suriname'
  },
  {
    code_a2: 'ss',
    code_a3: 'ssd',
    name: 'South Sudan'
  },
  {
    code_a2: 'st',
    code_a3: 'stp',
    name: 'São Tomé and Príncipe'
  },
  {
    code_a2: 'sv',
    code_a3: 'slv',
    name: 'El Salvador'
  },
  {
    code_a2: 'sx',
    code_a3: 'sxm',
    name: 'Saint Martin (Dutch part)'
  },
  {
    code_a2: 'sy',
    code_a3: 'syr',
    name: 'Syria'
  },
  {
    code_a2: 'sz',
    code_a3: 'swz',
    name: 'Swaziland'
  },
  {
    code_a2: 'tc',
    code_a3: 'tca',
    name: 'Turks and Caicos Islands'
  },
  {
    code_a2: 'td',
    code_a3: 'tcd',
    name: 'Chad'
  },
  {
    code_a2: 'tf',
    code_a3: 'atf',
    name: 'French Southern and Antarctic Lands'
  },
  {
    code_a2: 'tg',
    code_a3: 'tgo',
    name: 'Togo'
  },
  {
    code_a2: 'th',
    code_a3: 'tha',
    name: 'Thailand'
  },
  {
    code_a2: 'tj',
    code_a3: 'tjk',
    name: 'Tajikistan'
  },
  {
    code_a2: 'tk',
    code_a3: 'tkl',
    name: 'Tokelau'
  },
  {
    code_a2: 'tl',
    code_a3: 'tls',
    name: 'Timor-Leste'
  },
  {
    code_a2: 'tm',
    code_a3: 'tkm',
    name: 'Turkmenistan'
  },
  {
    code_a2: 'tn',
    code_a3: 'tun',
    name: 'Tunisia'
  },
  {
    code_a2: 'to',
    code_a3: 'ton',
    name: 'Tonga'
  },
  {
    code_a2: 'tr',
    code_a3: 'tur',
    name: 'Turkey'
  },
  {
    code_a2: 'tt',
    code_a3: 'tto',
    name: 'Trinidad and Tobago'
  },
  {
    code_a2: 'tv',
    code_a3: 'tuv',
    name: 'Tuvalu'
  },
  {
    code_a2: 'tw',
    code_a3: 'twn',
    name: 'Taiwan'
  },
  {
    code_a2: 'tz',
    code_a3: 'tza',
    name: 'Tanzania'
  },
  {
    code_a2: 'ua',
    code_a3: 'ukr',
    name: 'Ukraine'
  },
  {
    code_a2: 'ug',
    code_a3: 'uga',
    name: 'Uganda'
  },
  {
    code_a2: 'um',
    code_a3: 'umi',
    name: 'United States Minor Outlying Islands'
  },
  {
    code_a2: 'us',
    code_a3: 'usa',
    name: 'United States of America'
  },
  {
    code_a2: 'uy',
    code_a3: 'ury',
    name: 'Uruguay'
  },
  {
    code_a2: 'uz',
    code_a3: 'uzb',
    name: 'Uzbekistan'
  },
  {
    code_a2: 'va',
    code_a3: 'vat',
    name: 'City of the Vatican'
  },
  {
    code_a2: 'vc',
    code_a3: 'vct',
    name: 'Saint Vincent and the Grenadines'
  },
  {
    code_a2: 've',
    code_a3: 'ven',
    name: 'Venezuela'
  },
  {
    code_a2: 'vg',
    code_a3: 'vgb',
    name: 'British Virgin Islands'
  },
  {
    code_a2: 'vi',
    code_a3: 'vir',
    name: 'United States Virgin Islands'
  },
  {
    code_a2: 'vn',
    code_a3: 'vnm',
    name: 'Vietnam'
  },
  {
    code_a2: 'vu',
    code_a3: 'vut',
    name: 'Vanuatu'
  },
  {
    code_a2: 'wc',
    code_a3: 'wco',
    name: 'World Customs Organization'
  },
  {
    code_a2: 'wf',
    code_a3: 'wlf',
    name: 'Wallis and Futuna'
  },
  {
    code_a2: 'ws',
    code_a3: 'wsm',
    name: 'Samoa'
  },
  {
    code_a2: 'xc',
    code_a3: 'es-ce',
    name: 'Ceuta'
  },
  {
    code_a2: 'xk',
    code_a3: 'unk',
    name: 'Kosovo'
  },
  {
    code_a2: 'xl',
    code_a3: 'es-ml',
    name: 'Melilla'
  },
  {
    code_a2: 'ye',
    code_a3: 'yem',
    name: 'Yemen'
  },
  {
    code_a2: 'yt',
    code_a3: 'myt',
    name: 'Mayotte'
  },
  {
    code_a2: 'za',
    code_a3: 'zaf',
    name: 'South Africa'
  },
  {
    code_a2: 'zm',
    code_a3: 'zmb',
    name: 'Zambia'
  },
  {
    code_a2: 'zw',
    code_a3: 'zwe',
    name: 'Zimbabwe'
  }
];

/**
 * Converts an iso3166 Alpha 3 to it's iso3166 Alpha 2 counterpart
 * @param {String} iso3 the iso3166 Alpha 3 of a country
 * @returns {String|null} The iso3166 Alpha 2 counterpart or null if the iso alpha 3 could not be found
 */
function iso3toiso2(iso3) {
  if (!iso3) return null;
  const foundCountry = mapping.find((country) => country.code_a3 === iso3.toLowerCase());
  if (foundCountry) {
    return foundCountry.code_a2;
  } else {
    console.error(`the following iso3 was not found: ${iso3}`, 'iso3166mapping.js.iso3toiso2');
    return null;
  }
}

/**
 * Converts an iso3166 Alpha 2 to it's iso3166 Alpha 3 counterpart
 * @param {String} iso2 the iso3166 Alpha 2 of a country
 * @returns {String|null} The iso3166 Alpha 3 counterpart or null if the iso alpha 2 could not be found
 */
function iso2toiso3(iso2) {
  if (!iso2) return null;
  const foundCountry = mapping.find((country) => country.code_a2 === iso2.toLowerCase());
  if (foundCountry) {
    return foundCountry.code_a3;
  } else {
    console.error(`the following iso2 was not found: ${iso2}`, 'iso3166mapping.js.iso2toiso3');
    return null;
  }
}

/**
 * Attach a language to a country (mainly used to display the flag next to the language name)
 * @param {*} lang
 * @returns
 */
function langToCountryIso2(lang) {
  const foundCountry = mapping.find((country) => country.lang === lang);
  if (foundCountry) {
    return foundCountry.code_a2;
  } else {
    console.error(`the following language was not found: ${lang}`);
    return '';
  }
}

/**
 * Attach a language to a country (mainly used to display the flag next to the language name)
 * @param {*} t the "t" function from i18n
 * @returns a list of objects with two attributes; code_a2 and name (in current i18n language)
 */
function translatedCountryListIso2(t) {
  return mapping.map((country) => {
    return {
      code_a3: country.code_a3.toUpperCase(),
      code_a2: country.code_a2.toUpperCase(),
      name: t(`countries.${country.code_a2.toUpperCase()}`)
    };
  });
}

export default {
  countriesList: mapping,
  iso3toiso2,
  iso2toiso3,
  langToCountryIso2,
  translatedCountryListIso2
};
